import { tv, type VariantProps } from "tailwind-variants"

export type LineClampVariantProps = VariantProps<typeof lineClampVariants>

export const lineClampVariants = tv({
  base: "break-all",
  variants: {
    lines: {
      1: "line-clamp-1",
      2: "line-clamp-2",
      3: "line-clamp-3",
      4: "line-clamp-4",
      5: "line-clamp-5",
      6: "line-clamp-6",
      7: "line-clamp-7",
      8: "line-clamp-8",
      9: "line-clamp-9",
    },
  },
})
